var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5725 0.843745V5.34316C20.5725 6.09764 19.6453 6.46745 19.1092 5.93979L17.8339 4.6844L9.1366 13.2457C8.80185 13.5752 8.25917 13.5752 7.92441 13.2457L7.1163 12.4502C6.78155 12.1207 6.78155 11.5865 7.1163 11.257L15.8137 2.69563L14.5386 1.44038C14.0003 0.910542 14.3815 0 15.1447 0L19.7153 0C20.1887 0 20.5725 0.377752 20.5725 0.843745ZM14.5369 9.52006L13.9655 10.0826C13.8047 10.2408 13.7144 10.4554 13.7144 10.6792V15.7499H2.28574V4.49998H11.7144C11.9417 4.49997 12.1597 4.41109 12.3205 4.25287L12.8919 3.69038C13.4319 3.15882 13.0494 2.25 12.2858 2.25H1.7143C0.767507 2.25 0 3.0055 0 3.93749L0 16.3124C0 17.2444 0.767507 17.9999 1.7143 17.9999H14.2858C15.2326 17.9999 16.0001 17.2444 16.0001 16.3124V10.1167C16.0001 9.36495 15.0769 8.9885 14.5369 9.52006Z",
    fill: "#D64309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.c2a70b5f89cfac53ffd509635c0f676b.svg";
export { ForwardRef as ReactComponent };